// Geographic center of the contiguous United States (near Lebanon, KS).
// Used as the final fallback when a logged-in company has no default lat/lon set.
export const DEFAULT_MAP_CENTER = { lng: -98.5795, lat: 39.8283 };
